import React from "react";
import Image1 from "../assets/images/e-card-1.png";
import Image2 from "../assets/images/e-card-2.png";
import Image3 from "../assets/images/e-card-3.png";
const Economy = () => {
  const data = [
    {
      img: Image1,
      title: " MOZZLE / ETH liquidity pool",
      text: "Our games are designed to continuously add more liquidity for the MOZZLE token.",
      list: [
        {
          title: "Token Name",
          data: "Mozzle Doge",
        },
        {
          title: "Symbol",
          data: " $MOGE",
        },
      ],
    },
    {
      img: Image2,
      title: " Buying Pressure",
      text: "After fresh liquidity is added the game buys more tokens from the DEX.",
      list: [
        {
          title: "Buy & Sell tax",
          data: "7%",
        },
        {
          title: "(2% Jackpot | 1% Auto LP | 4% Marketing)",
          data: "",
        },
      ],
    },
    // {
    //   img: Image3,
    //   title: "Burning MOZZLE tokens",
    //   text: "Finally the tokens that were purchased are burned.",
    //   list: [
    //     {
    //       title: "Auto LP",
    //       data: " 1%",
    //     },
    //     {
    //       title: "Jackpot",
    //       data: " 2%",
    //     },
    //   ],
    // },
  ];
  return (
    <section className="py-20">
      <div className="container">
        <div className="p-4 py-8 md:p-8   rounded-3xl">
          <h2 className="text-[30px] md:text-[90px] text-center uppercase">
            Tokenomics
          </h2>
          <p className=" font-serif max-w-3xl mx-auto  text-center font-normal ">
            Mozzle Doge has unique tokenomics which rewards every 50th buyer in
            ETH. 2% tax is collected in a wallet and is automatically airdropped
            to every 50th buyer of $MOGE tokens.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-6 md:gap-4 max-w-6xl mx-auto">
            {data.map((val, i) => (
              <div
                key={i}
                className="text-center  flex flex-col justify-between"
              >
                {/* <img src={val.img} alt="" className="mx-auto w-40" /> */}
                {/* <h5 className="text-2xl uppercase font-bold mt-5 mb-2 max-w-[250px] mx-auto">
                  {i + 1}. {val.title}
                </h5> */}
                <ul>
                  {val.list.map((val, i) => (
                    <li key={i}>
                      <p className="text-lg">
                        {`${val.title}`} { val.data && `:${val.data}`}
                      </p>
                    </li>
                  ))}
                </ul>
                {/* <p className=" font-serif font-normal max-w-[260px] mx-auto">
                  {val.text}
                </p> */}

                {/* <button className="bg-primary py-2 px-6 rounded-full text-primary-text mt-2 mx-auto block">
                  Read More
                </button> */}
              </div>
            ))}
          </div>
          <p className="mt-8 max-w-lg mx-auto text-center ">
            Note - A maximum tax limit of 15% is hardcoded in the Mozzle Doge
            smart contract. Which means, tax can't be increased beyond 15% after
            the contract was deployed.
          </p>
        </div>
        {/* <div className="mt-16 bg-primary py-16 px-4 rounded-3xl">
          <h2 className="text-primary-text uppercase text-center text-[28px] md:text-[70px] break-words">
            Deflationary
          </h2>
          <p className="text-primary-text font-serif text-center text-lg md:text-2xl font-medium">
            50% of it is burnt, 50% is collected in the game contract
          </p>
        </div> */}
        {/* <div className="mt-16 economy-box p-4 md:p-8 py-10 md:py-28  border-l-[3px] border-primary rounded-3xl">
          <h2 className=" uppercase text-center text-[20px] md:text-[60px] mb-4">
            Once you start the game, there is no turning back
          </h2>
          <p className=" font-serif text-center text-base md:text-4xl font-medium max-w-5xl mx-auto">
            Place bet and you can either win or lose. On winning you will get
            your whole betted amount whereas on loosing 50% of betted amount
            will be burned
          </p>
        </div> */}
      </div>
    </section>
  );
};

export default Economy;
